"use client";

import { useState } from "react";
import { AudioModeToggle } from "@/components/audio-mode-toggle";
import { Chat } from "@/components/chat";
import { ParamInputs } from "@/components/param-inputs";
import { PlaybookSelector, type Selection } from "@/components/playbook-selector";
import { usePlaybookParams } from "@/hooks/usePlaybookParams";
import { useWebSocketSession } from "@/hooks/useWebSocketSession";
import { createSessionFromSelection } from "@/lib/api";
import { type AudioMode } from "@/lib/ws";

export default function VoiceCallPage() {
  const [audioMode, setAudioMode] = useState<AudioMode>("file");
  const [isAgent, setIsAgent] = useState(false);
  const { paramNames, paramValues, setParamValues, resetParams, params } = usePlaybookParams();
  const { sessionId, messages, ended, callStatus, handleSessionStart, hangUp } =
    useWebSocketSession(audioMode);

  async function handleStart(selection: Selection) {
    setIsAgent(selection.type === "agent_backend");
    const res = await createSessionFromSelection(selection, { source: "sandbox:voice-call", params });
    handleSessionStart(res.session_id, res.reply);
  }

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-3 border-b px-4 py-3">
        <h1 className="text-sm font-medium">语音对话</h1>
        <PlaybookSelector onStart={handleStart} onPlaybookChange={resetParams} disabled={callStatus !== "idle"} />
        <AudioModeToggle value={audioMode} onChange={setAudioMode} disabled={callStatus !== "idle"} />
        <ParamInputs params={paramNames} values={paramValues} onChange={setParamValues} disabled={callStatus !== "idle"} />
      </div>
      <div className="flex-1 overflow-hidden">
        {sessionId ? (
          <Chat
            messages={messages}
            ended={ended}
            loading={false}
            onSend={() => {}}
            sessionId={sessionId}
            callStatus={callStatus}
            onHangUp={hangUp}
            enableMarkdown={isAgent}
          />
        ) : (
          <div className="flex h-full items-center justify-center text-muted-foreground">
            请选择话术并开始会话
          </div>
        )}
      </div>
    </div>
  );
}
